import React from 'react';
import './About.css';
import ParticleCanvas from './ParticleCanvas';

export default function About({ t }) {
  return (
    <section id="about" className="about">
      <ParticleCanvas preset="dust" />
      <div className="about-inner">
        <div className="about-deco">IX</div>
        <h2 className="section-title">{t.title}</h2>
        <div className="flame-divider"><span>✦</span></div>
        {t.body.split('\n\n').map((para, i) => (
          <p key={i} className="about-body">{para}</p>
        ))}
        <a href={t.hedoneUrl} target="_blank" rel="noopener noreferrer" className="about-hedone">
          {t.hedoneLabel}
        </a>
        <blockquote className="about-quote">
          <p>{t.quote}</p>
          <cite>{t.quoteAuthor}</cite>
        </blockquote>
      </div>
    </section>
  );
}
